import { render } from "./filterRating.vue?vue&type=template&id=58816370"
import script from "./filterRating.vue?vue&type=script&lang=js"
export * from "./filterRating.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__